{
  "results": {
    "title": "結果",
    "description": "每次計算都會建立一份不可變更的結果紀錄，先前的計算結果仍可供稽核查詢。",
    "calculate": "計算結果",
    "calculateWarning": "此操作只會納入至少 2 位評審完成鎖定評分、且無進行中利益衝突的作品；未達門檻的作品將於下方列為「缺少有效評分」。",
    "calculateConfirm": "確認計算",
    "calculateSuccess": "結果已計算完成。",
    "calculateFailed": "無法計算結果。",
    "lock": "鎖定",
    "lockWarning": "鎖定後仍可調整獎項等第（須附理由），直到公布為止；公布後即不可變更，如需修正須重新計算。不影響其他結果紀錄，此紀錄本身也不會被刪除。",
    "lockConfirm": "確認鎖定",
    "publish": "發布",
    "transitionSuccess": "已更新結果狀態。",
    "transitionFailed": "無法更新結果狀態。",
    "roundsTablist": "賽程輪次",
    "categoriesTablist": "組別",
    "allCategories": "不分組",
    "metadata": {
      "runId": "結果紀錄 ID",
      "round": "賽程輪次",
      "category": "組別",
      "calculatedAt": "計算時間",
      "calculatedBy": "計算者",
      "included": "已納入評分",
      "missing": "缺少有效評分",
      "tie": "並列",
      "tieValue": "有兩個以上作品分數相同",
      "lockedBy": "鎖定者",
      "publishedBy": "發布者",
      "disqualified": "已取消資格（不計入）"
    },
    "awardTiers": {
      "none": "未覆核",
      "first": "第一名",
      "second": "第二名",
      "third": "第三名",
      "honorable": "佳作",
      "vacant": "從缺"
    },
    "reviewComments": {
      "expandAll": "展開全部審查意見",
      "collapseAll": "收合全部審查意見",
      "toggle": "查看評審的審查意見",
      "empty": "尚無已送出的評分。",
      "blank": "（未填寫審查意見）"
    },
    "override": {
      "reasonPlaceholder": "調整理由（必填）",
      "apply": "套用"
    },
    "advancement": {
      "title": "決定入圍名單",
      "description": "根據下方的結算結果，勾選要晉級到「{{round}}」的隊伍。",
      "noRun": "請先計算此輪次的結果。",
      "empty": "目前沒有可供入圍的結果。",
      "topN": "取前 N 名",
      "selectTopN": "選取前 N 名",
      "selectRow": "選取 {{team}} 入圍",
      "advanced": "已入圍",
      "confirm": "確認 {{count}} 隊入圍",
      "confirming": "即將標記以下 {{count}} 隊入圍「{{round}}」，此動作會公開結果，系統會以 Email 通知這些隊伍的隊員（不含教師），請確認名單無誤：",
      "confirmSubmit": "確認送出",
      "confirmed": "已有 {{count}} 隊入圍。",
      "failed": "無法確認入圍名單。"
    },
    "disqualifiedNotice": "以下隊伍已取消資格，不計入此結果：{{teams}}。公布前請確認。",
    "manualBreakdown": "評審 {{judge}}，手動 {{manual}}"
  }
}
